export const table = {
  primaryData: [
    { title: "ID", value: "id", type: "configue" },
    { title: "NLearn4 Employee ID", value: "employeeId", type: "configue" },
    { title: "Global Employee ID", value: "employeeCode", type: "configue" },
    { title: "First Name", value: "empFirstName", type: "configue" },
    { title: "Last Name", value: "empLastName", type: "configue" },
    { title: "Department", value: "departmentName", type: "configue" },
    { title: "Designation", value: "designationName", type: "configue" },
    { title: "IsArchived", value: "isArchived", type: "configue" },
  ],
  secondaryData: [
    { title: "Created At", value: "createdAt", type: "configue" },
    { title: "Updated At", value: "updatedAt", type: "configue", name:"updatedAt" },
    { title: "Created By", value: "createdByName", type: "configue" },
    { title: "Updated By", value: "updatedByName", type: "configue", name:"updatedByName" },
  ],
};
